import { createCustomAction, createStandardAction } from "typesafe-actions";
import { GenericUser, User } from "generated/graphql";

export enum CategoryName {
  GROUPED_USERS = "GROUPED_USERS",
  AVAILABLE_TO_ADD = "AVAILABLE_TO_ADD"
}

export enum Tab {
  GROUPED_USERS,
  AVAILABLE_TO_ADD,
  PENDING_USERS
}

export type SharedCategoryState = {
  selectedItems: Array<string>;
  searchTerm?: string;
  cursor: string | null;
  pageLoading: boolean;
  actionInProgress: boolean;
};

export type RootState = {
  tab: Tab;
};

export type DeviceUserGroupOverviewState = {
  root: RootState;
  groupedUsersCategory: SharedCategoryState;
  availableUsersCategory: SharedCategoryState;
};

export const CategoryActions = {
  updateSelectedItems: createCustomAction(`UpdateSelectedItems`, type => {
    return (
      category: CategoryName,
      payload: SharedCategoryState["selectedItems"]
    ) => ({ type, category, payload });
  }),
  updateSearchTerm: createCustomAction(`UpdateSearchTerm`, type => {
    return (
      category: CategoryName,
      payload: SharedCategoryState["searchTerm"]
    ) => ({ type, category, payload });
  }),
  updateCursor: createCustomAction(`UpdateCursor`, type => {
    return (
      category: CategoryName,
      payload: SharedCategoryState["cursor"]
    ) => ({ type, category, payload });
  }),
  updatePageLoading: createCustomAction(`UpdatePageLoading`, type => {
    return (
      category: CategoryName,
      payload: SharedCategoryState["pageLoading"]
    ) => ({ type, category, payload });
  }),
  updatePageLoadingAndCursor: createCustomAction(
    `UpdatePageLoadingAndCursor`,
    type => {
      return (
        category: CategoryName,
        payload: Pick<SharedCategoryState, "pageLoading" | "cursor">
      ) => ({ type, category, payload });
    }
  ),
  updateActionInProgress: createCustomAction("UpdateActionInProgress", type => {
    return (
      category: CategoryName,
      payload: SharedCategoryState["actionInProgress"]
    ) => ({ type, category, payload });
  }),
  updateActionInProgressAndCursor: createCustomAction(
    `UpdateActionInProgressAndCursor`,
    type => {
      return (
        category: CategoryName,
        payload: Pick<SharedCategoryState, "actionInProgress" | "cursor">
      ) => ({ type, category, payload });
    }
  )
};

export type CategoryActionTypes = typeof CategoryActions;

export const RootActions = {
  updateTab: createStandardAction("UpdateTab")<RootState["tab"]>()
};

export type RootActionTypes = typeof RootActions;

export type GroupedUser = Pick<User, "name" | "user_id" | "email" | "nickname">;
export type AvailableUser = Pick<User, "name" | "user_id" | "email">;

export type PendingUser = Pick<GenericUser, "name" | "email">;
